import React from "react";
import PropTypes from "prop-types";

const PhonePreview = (props) => {
    const { Phone = "" } = props;
    return (
        Phone.length > 0 && (
            <div className="phone-preview" data-testid="phone-preview">
                <div className="grid">
                    <div className="col col--12 col--no-top-gutter">
                        <div className="phone-preview__phone -callout">
                            <p>{Phone}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

PhonePreview.propTypes = {
    Phone: PropTypes.string.isRequired,
};

export default PhonePreview;
